export const COOKIE_BANNER_TRIGGER = ".js-privacy-wire-notice-toggle";
export const COOKIE_OPTIONS_LOCALSTORAGE_NAME = "privacywire";
